import MediumEditor from 'medium-editor'
import rangy from 'rangy'
import {ICONS} from './medium-editor-icons'


import * as $utils from 'utils';
export const getSelectionParentNode = () => {
  const sel = rangy.getSelection()
  if (sel.rangeCount > 0) {
    const range = sel.getRangeAt(0)
    let parent_element = range.commonAncestorContainer
    if (parent_element.nodeType == 3) {
      parent_element = parent_element.parentNode
    }
    return parent_element
  }
}

export const getSelectionHTML = () => {
  return rangy.getSelection().toHtml()
}

export const createToolbarButton = (name, icon, onClick) => {
  const Extension = MediumEditor.Extension.extend({
    name,
    init() {
      initButton.call(this, icon)
    },

    getButton() {
      return this.button
    },


    async handleClick(event) {
      onClick(this.name, event)
    }
  })
  return new Extension()
}


export const createToolbarDivider = () => {
  const Extension = MediumEditor.Extension.extend({
    name: '',
    init() {
      initButton.call(this, ICONS.divider, 'medium-editor-divider')
    },

    getButton() {
      return this.button
    },
    async handleClick(event) {}
  })
  return new Extension()
}

function initButton(icon_html, classname = 'medium-editor-action') {
  this.button = this.document.createElement('button')
  this.button.classList.add(classname)
  this.button.innerHTML = icon_html
  this.button.title = $utils.str.capitalize(this.name)
  this.on(this.button, 'click', this.handleClick.bind(this))
}